import Loading from "src/components/common/Loading/Loading";
import Table from "src/components/common/tables";
import { TableCell } from "src/components/common/tables/TableCell";
import { TableHeader } from "src/components/common/tables/TableHeader";
import { TableRow } from "src/components/common/tables/TableRow";

const SearchedProperties = ({ searchedProperties, loadingSearchedProperties }) => {
    return (
        <>
            {loadingSearchedProperties ? (
                <Loading height="80%" />
            ) : (

                searchedProperties?.length > 0 &&
                (

                    <Table>
                        <thead>
                            {[
                                'Id',
                                'Colonia',
                                'Ciudad',
                                'Estado',
                            ].map(
                                (item) => (
                                    <TableHeader key={item}>{item}</TableHeader>
                                )
                            )}
                        </thead>
                        {
                            <tbody>
                                {searchedProperties.map((searchedProperty) => (
                                    <TableRow key={`row-codes-${searchedProperty.id}`}>
                                        <TableCell>{searchedProperty.id}</TableCell>
                                        <TableCell>{searchedProperty.colony}</TableCell>
                                        <TableCell>{searchedProperty.city}</TableCell>
                                        <TableCell>{searchedProperty.state}</TableCell>
                                    </TableRow>
                                ))}
                            </tbody>

                        }
                    </Table>
                )

            )}
        </>
    )
}

export default SearchedProperties;